import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'view-design/dist/styles/iview.css'
import fetch from './fetch/fly'
import { Message } from 'view-design'
import { baseHost } from './config/index'
import './router/intercept'
import GL_Component from '@/utils/globalComponents'
import { parseTime } from './utils/index'
import { toThousands } from './utils/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import VueParticles from 'vue-particles'
import moment from 'moment'

import VueMarkdownEditor from '@kangc/v-md-editor'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/vuepress.css'
// highlightjs
import hljs from 'highlight.js'

// codemirror 编辑器的相关资源
import Codemirror from 'codemirror'

// Prism
import Prism from 'prismjs'
// highlight code
import 'prismjs/components/prism-json'
// mode
import 'codemirror/mode/markdown/markdown'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/mode/css/css'
import 'codemirror/mode/htmlmixed/htmlmixed'
import 'codemirror/mode/vue/vue'
// edit
import 'codemirror/addon/edit/closebrackets'
import 'codemirror/addon/edit/closetag'
import 'codemirror/addon/edit/matchbrackets'
// placeholder
import 'codemirror/addon/display/placeholder'
// active-line
import 'codemirror/addon/selection/active-line'
// scrollbar
import 'codemirror/addon/scroll/simplescrollbars'
import 'codemirror/addon/scroll/simplescrollbars.css'
// style
import 'codemirror/lib/codemirror.css'
VueMarkdownEditor.Codemirror = Codemirror
VueMarkdownEditor.use(vuepressTheme, {
  Prism
})
VueMarkdownEditor.use(githubTheme, {
  Hljs: hljs
})

Vue.use(VueMarkdownEditor)

moment.locale('zh-cn')

// use
Vue.prototype.$moment = moment
Vue.use(VueParticles)
Vue.use(VueAwesomeSwiper)
Vue.config.productionTip = false
Vue.prototype.$fetch = fetch
Vue.prototype.$msg = Message
Vue.prototype.parseTime = parseTime
Vue.prototype.toThousands = toThousands
Vue.prototype.baseHost = baseHost

// 全局组件
Vue.use(GL_Component)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
